import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { useHistory } from '@fs/zion-router'
import { colors, List, ListItem, useAtSize } from '@fs/zion-ui'
import { SurnameIndexItem } from '../../types/data-types'
import { getPathFromUrl } from '../../services/url-service'
import sendAnalytics from '../../services/analytics-helper'
import { getName } from '../../services/surname-index-service'

const rangeCss = css`
  color: ${colors.link.primary};
`

export default function IndexList({ items }: { items: SurnameIndexItem[] | undefined }): JSX.Element {
  const [t] = useTranslation()
  const history = useHistory()
  const atSize = useAtSize()
  const isMobile = atSize({ default: true, md: false })
  return (
    <div>
      <List>
        {items &&
          items.map((item, index) => {
            const key = `${index}`
            return (
              <ListItem
                data-testid="surname-list-item"
                primaryText={
                  <>
                    <span css={rangeCss}>{getName(t, item.givenNamesRangeStart, item.surnameRangeStart)}</span>{' '}
                    <span>({item.lifespanRangeStart})</span> -{' '}
                    <span css={rangeCss}>{getName(t, item.givenNamesRangeEnd, item.surnameRangeEnd)}</span>{' '}
                    <span>({item.lifespanRangeEnd})</span>
                  </>
                }
                onClick={() => {
                  window?.scrollTo && window?.scrollTo(0, 0)
                  history.push(getPathFromUrl(item.url, true))
                  sendAnalytics({ link_page: 'Surname Index', link_name: 'List Item' })
                }}
                key={key}
                dense={!isMobile}
              />
            )
          })}
      </List>
    </div>
  )
}
